import { RouteConfig } from "vue-router";

export const RCompanySummary: RouteConfig = {
  path: "summary",
  name: "CompaniesSummary",
  component: () =>
    import(
      /* webpackChunkName: "companies-template-summary" */
      "./VCompanySummary.vue"
    ),
  meta: {
    label: "summary",
    title: "Companies",
  },
};
